export const quartilesRule = {
  id: 'quartiles',
  name: 'Quartile Progression',
  description: 'Quartile events should fire in order: firstQuartile -> midpoint -> thirdQuartile -> complete',

  check(session) {
    const quartileEvents = ['adfirstquartile', 'admidpoint', 'adthirdquartile', 'adcomplete'];
    const found = session.events.filter(e => quartileEvents.includes(e.type));
    const errorEvents = session.events.filter(e => e.type === 'aderror');
    const skippedEvents = session.events.filter(e => e.type === 'adskipped');

    if (errorEvents.length > 0 && found.length === 0) {
      return { status: 'na', message: 'Ad errored before quartiles could fire' };
    }

    if (skippedEvents.length > 0) {
      // If skipped, partial quartiles are acceptable
      if (found.length === 0) {
        return { status: 'na', message: 'Ad was skipped before any quartile fired' };
      }
      return { status: 'pass', message: `Ad skipped after ${found.length} quartile(s) fired` };
    }

    if (found.length === 0) {
      return { status: 'fail', message: 'No quartile events fired' };
    }

    // Check order
    const foundTypes = found.map(e => e.type);
    let prevIndex = -1;
    for (const type of foundTypes) {
      const index = quartileEvents.indexOf(type);
      if (index <= prevIndex) {
        return { status: 'fail', message: `Quartile events out of order: ${foundTypes.join(' -> ')}` };
      }
      prevIndex = index;
    }

    // Check if all four fired
    if (found.length < 4) {
      return { status: 'fail', message: `Only ${found.length}/4 quartile events fired: ${foundTypes.join(', ')}` };
    }

    return { status: 'pass', message: 'All quartiles fired in correct order' };
  },
};
